import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { getListonDynamic } from '@shared/helpers/addTextStyle';
import { Switch, Route, Redirect } from 'react-router-dom';
import {
  ROOT,
  HOTELS,
  FLIGHTS,
  LOGIN,
  ASSIST,
  COMPANY,
  REGISTER,
  HOTEL_VOUCHER,
  SELLPOINTS,
  PLATES_DETAIL,
  MAINTENANCE,
  WORKWITHUS,
  OCEANFEST,
  MIGIT,
  MIGIT_URL,
} from '@shared/helpers/routes';
import { setIntegrations, setProviders } from '@shared/redux/actions';
import { getProviders, getintegrations } from '@shared/services/services';
import http from '@shared/services/http/interceptor';
import Layout from '@shared/layout';
import AuthRouter from './AuthRouter';
import PrivateRoute from './PrivateRoute';
import PublicOrPrivateRouter from './PublicOrPrivateRouter';
import { Box, CircularProgress, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import AssistCard from '@shared/pages/AssistCard';
import HotelsPage from '@shared/pages/Hotels';
import Flights from '@shared/pages/Flights';
import HotelBookingDone from '@shared/pages/Hotels/HotelBookingDone';
import Plates from '@shared/pages/Plates';
import Company from '@sites/pages/Company';
import SellPoints from '@shared/pages/SellPoints';
import WorkWithUs from '@shared/pages/WorkWithUs';
import Maintenance from '@shared/pages/Maintenance';
import Oceanfest from '@shared/pages/Oceanfest';
import ExternalRedirect from '@shared/pages/ExternalRedirect';

const AppRouter = ({ children, childrenNoLayout }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pageConfiguration = useSelector(store => store.pageConfiguration);
  const theme = useTheme();

  const [isRefreshing, setIsRefreshing] = useState(false);
  const [refreshDone, setRefreshDone] = useState(false);

  const isAuthLocation =
    location.pathname !== LOGIN &&
    !location.pathname.includes('/login-motorstatic') &&
    location.pathname !== REGISTER &&
    !location.pathname.includes('/recover');

  useEffect(() => {
    getListonDynamic();

    getProviders().then(res => dispatch(setProviders(res.data)));
    getintegrations().then(res => dispatch(setIntegrations(res)));

    // 🔹 Esperar refresh si hay
    if (http.refreshPromise) {
      console.log('[AppRouter] waiting for refresh...');
      setIsRefreshing(true);
      http.refreshPromise
        .then(() => {
          console.log('[AppRouter] refresh done');
        })
        .finally(() => {
          setIsRefreshing(false);
          setRefreshDone(true);
        });
    } else {
      setRefreshDone(true);
    }
  }, []);

  // Loader mientras refresh o configuración
  if (!refreshDone || !pageConfiguration?.id || isRefreshing) {
    return (
      <Box
        sx={{
          display: 'flex',
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Aplicar colores del tema
  document.body.style.setProperty('--primary-color', theme.primary);
  document.body.style.setProperty('--tertiary-color', theme.tertiary);
  document.body.style.setProperty('--colorText1-color', theme.text1);
  document.body.style.setProperty('--colorText2-color', theme.text2);

  if (!isAuthLocation) {
    console.log('[AppRouter] redirecting to AuthRouter');
    return <AuthRouter pageConfiguration={pageConfiguration} />;
  }

  return (
    <Switch>
      <Route exact path={MIGIT}>
        <ExternalRedirect to={MIGIT_URL} />
      </Route>
      <Route exact path={COMPANY}>
        <Company />
      </Route>
      {childrenNoLayout}
      <Layout>
        <Switch>
          <Route exact path={ROOT}>
            <Redirect to={FLIGHTS} />
          </Route>
          <Route exact path={OCEANFEST}>
            <Oceanfest />
          </Route>
          <Route exact path={FLIGHTS}>
            <Flights />
          </Route>
          <Route exact path={HOTELS}>
            <HotelsPage />
          </Route>
          <Route exact path={HOTEL_VOUCHER}>
            <HotelBookingDone />
          </Route>
          <Route exact path={ASSIST}>
            <AssistCard />
          </Route>
          <Route exact path={SELLPOINTS}>
            <SellPoints />
          </Route>
          <Route exact path={WORKWITHUS}>
            <WorkWithUs />
          </Route>
          <Route path={PLATES_DETAIL}>
            <Plates location={location} />
          </Route>
          <Route path={MAINTENANCE}>
            <Maintenance />
          </Route>
          {children}
          <PrivateRoute
            exact
            isPrivate={pageConfiguration.business_types.code === 'BTB'}
          >
            <PublicOrPrivateRouter
              site_functions={pageConfiguration.site_functions}
            />
          </PrivateRoute>
        </Switch>
      </Layout>
    </Switch>
  );
};

export default AppRouter;
